import { MailerService } from './../../../../../services/shared/mailer.service';
import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Solicitud } from '../../../../../interfaces/interface-bakend/ofertas-laborales/solicitudes.interface';
import { SolicitudesService } from '../../../../../services/ofertas-laborales/solicitudes.service';
import { User } from '../../../../../interfaces/interface-bakend/seguridad/users/user.interface';
import { ActividadesService } from '../../../../../services/ofertas-laborales/actividades.service';
import {
    MatDialog,
    MatDialogRef,
    MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { UploadFileSolicitudComponent } from '../../../common/upload-file-solicitud/upload-file-solicitud.component';
import { OfertasImageViewerComponent } from '../../../common/ofertas-image-viewer/ofertas-image-viewer.component';
import { MediaService } from '../../../../../services/shared/media.service';
import { CatalogoService } from '../../../../../services/shared/catalogo.service';
import { Actividad } from '../../../../../interfaces/interface-bakend/ofertas-laborales/actividad.interface';
import {
    APP_CONFIG_OFERTAS,
    IAppOfertas,
} from '../../../../../app.config/app.config-ofertas';
import { Subscription } from 'rxjs';
import { UserEntreUser } from '@interfaces/interface-bakend/seguridad/users/user-entre-user.interface';
import { UserEntreUserService } from '@services/shared/user-entre-user.service';
import { PDFDocument } from 'pdf-lib';
import { UsuarioService } from '@services/shared/usuario.service';
import { AuthService } from '@services/auth/auth.service';
import { environment } from '@env/environment';
import { PopUpModalCustomService } from '@services/shared/popup-modal-custom.service';
import {
    RECUPERO_ACTIVIDADES,
    RECUPERO_PERFIL_KEY,
} from '../../../common/helpers/recupero.helper';

@Component({
    selector: 'app-ofertas-solicitud',
    templateUrl: './ofertas-solicitud.component.html',
    styleUrls: ['./ofertas-solicitud.component.scss'],
})
export class OfertasSolicitudComponent implements OnInit, OnDestroy {
    // Estados
    activarEnRevision: boolean = false;
    activarEnAuditoria: boolean = false;
    activarAprobar: boolean = false;
    activarRechazar: boolean = false;
    activarEnvio: boolean = false;
    activarCerrarModal: boolean = true;
    activarEnEspera: boolean = true;
    activarDeshacerAnulacion: boolean = false;
    /** Estado que muestra el stepper: si está en espera, el estado heredado. */
    estadoParaStepper: number;

    // Habilitacion del Boton Aprobar solo si subio el archivo
    flagDisableButtonApprove: boolean = true;
    flagCargaCorrecta: boolean = false;
    selectedFile: File;
    selectedFileName: string = '';
    value: number = 0;
    isActive: boolean = false;
    subscriptionAvance: Subscription;

    motivoRevision: string = '';
    motivoRechazo: string = '';
    motivoEnEspera: string = '';
    nombrePais: string;
    actividad: Actividad;
    solicitud: Solicitud;
    usuario: User;

    flagLoaded: boolean;
    flagSpinner: boolean = false;
    flagEnRevision: boolean = false;
    flagEnAuditoria: boolean = false;
    flagEnRecupero: boolean = false;
    flagLabelAprobado: boolean = false;
    flagLabelRechazado: boolean = false;
    flagLabelPresentado: boolean = false;
    flagLabelEnEspera: boolean = false;

    isCheckedAprobar: boolean = false;
    isCheckedRechazar: boolean = false;
    isCheckedEnRevision: boolean = false;
    isCheckedEnviarDocumentos: boolean = false;
    isCheckedEnEspera: boolean = false;

    dataModal: any;

    estadoDocumentacion: string;

    imgs: string[] = [];
    filesAfiliado: string[] = [];
    filesAdmin: string[] = [];
    nombresImagenes: { [key: string]: string } = {};

    adjuntoCatalogo: any;
    idioma: Subscription;
    newState: Subscription;

    habilitarEnviarObservacion: boolean = false;
    botonAuditoriaHabilitado: boolean = true;
    mostrarLeyenda: boolean = false;
    beneficiario: UserEntreUser;

    observacionEmailAuditoriaMedica: string = '';

    selectedFiles: any[] = [];

    observacionInterna: string = '';
    habilitarGuardarObservacionInterna: boolean = false;

    // Circuito Recupero (PoC frontend-only): Medicamentos + Empadronamiento medicación crónica
    private readonly PERFILES_MANDAR_RECUPERO = [
        'SEDE',
        RECUPERO_PERFIL_KEY,
        'AUDITORIA',
        'ADMIN',
        'SYSADMIN',
    ];
    private readonly PERFILES_DERIVAR_AUDITORIA = [
        RECUPERO_PERFIL_KEY,
        'AUDITORIA',
        'ADMIN',
        'SYSADMIN',
    ];
    private readonly PERFILES_RESOLUCION_AUDITORIA = ['AUDITORIA', 'ADMIN', 'SYSADMIN'];
    private readonly PERFILES_TODOS = ['SEDE', 'ADMIN', 'SYSADMIN', RECUPERO_PERFIL_KEY, 'AUDITORIA'];
    userPerfilKey: string;
    esTramiteRecupero: boolean = false;
    activarEnRecupero: boolean = false;
    observacionRecupero: string = '';


    constructor(
        @Inject(APP_CONFIG_OFERTAS) private iAppOfertas: IAppOfertas,
        @Inject(MAT_DIALOG_DATA) public data: string,
        public dialogRef: MatDialogRef<OfertasSolicitudComponent>,
        private router: Router,
        private solicitudesService: SolicitudesService,
        private mediaService: MediaService,
        public dialog: MatDialog,
        private mailerService: MailerService,
        private catalogoService: CatalogoService,
        private userEntreUserService: UserEntreUserService,
        private usuarioService: UsuarioService,
        private actividadesService: ActividadesService,
        private authService: AuthService,
        private modalCustom: PopUpModalCustomService,
    ) {
        this.newState = this.solicitudesService
            .getsetNewStater()
            .subscribe((resp) => {
                this.initPostChangeStatus();
                this.newState = resp;
            });
        this.mediaService.reiniciarContadorControlUpload();
        this.subscribeAvanceUpload();
    }

    ngOnInit(): void {
        this.getDataSolicitud();
        this.cargarAdjuntoContrato();
    }

    get coberturaSolicitud(): string {
        return this.solicitudesService.getCoberturaSolicitud();
    }

    get chipEstado(): string {
        switch (this.solicitud?.lastState?.numberState) {
            case 4:
                return 'ds-chip--aprobado';
            case 3:
                return 'ds-chip--auditoria';
            case 2:
                return 'ds-chip--revision';
            case 7:
                return 'ds-chip--recupero';
            case 6:
                return 'ds-chip--espera';
            case 5:
                return 'ds-chip--anulado';
            default:
                return 'ds-chip--neutro';
        }
    }

    /**
     * Estado inmediatamente anterior a "En Espera" (6), leído del histórico.
     * Se saltean los 6 del final para soportar esperas encadenadas.
     */
    private get estadoPrevioAlEspera(): number | null {
        const states = this.solicitud?.states;
        if (!states || states.length === 0) {
            return null;
        }
        let i = states.length - 1;
        while (i >= 0 && states[i]?.numberState === 6) {
            i--;
        }
        return i >= 0 ? states[i].numberState : null;
    }

    /**
     * Estado al que vuelve la solicitud al salir de Espera. Para estados de
     * gestión (2, 3, 4, 7) devuelve el estado exacto anterior; para Presentado
     * (0), Documentación (1) o sin histórico, cae a En Revisión (2).
     */
    get estadoRetornoEspera(): number {
        const previo = this.estadoPrevioAlEspera;
        if (previo !== null && previo >= 2 && previo !== 5) {
            return previo;
        }
        return this.iAppOfertas.estado_2.number;
    }

    // =====================================================
    // Popup custom (movido a PopUpModalCustomService)
    // =====================================================

    ngOnDestroy(): void {
        this.modalCustom.cerrar();
    }

    initPostChangeStatus(): void {
        this.getDataSolicitud();
        this.activarCerrarModal = true;
    }

    clearSelectionFile() {
        this.selectedFile = null;
        this.selectedFileName = '';
        this.isActive = false;
    }

    subscribeAvanceUpload() {
        this.subscriptionAvance = this.mediaService
            .getAvance()
            .subscribe((resp) => {
                if (resp) {
                    this.value = resp.value;
                } else {
                    this.value = 0;
                }
            });
    }

    async getDataSolicitud() {
        console.log(await this.getSolicitud());
        this.flagLoaded = false;

        await this.cargarPerfilYReglaRecupero();
        await this.getEstadoSolicitud(await this.getSolicitud());
        await this.getArrayImgsAndFile((await this.getSolicitud()).adjuntos);
        await this.setNombresAdjuntos();
        await this.getBeneficiario(this.solicitud);

        this.observacionInterna = this.solicitud?.observacionInterna || '';
        this.habilitarBotonObservacionesInternas(this.observacionInterna);

        this.flagLoaded = true;
    }

    private async cargarPerfilYReglaRecupero(): Promise<void> {
        try {
            const userLogon = await this.authService.getUserLogon();
            this.userPerfilKey = userLogon?.perfil?.key;
        } catch (error) {
            console.warn('No se pudo obtener el perfil del usuario logueado:', error);
            this.userPerfilKey = undefined;
        }

        const actividad = (this.solicitud?.actividad as any);
        const actividadId =
            typeof actividad === 'object' && actividad !== null
                ? actividad._id
                : actividad;
        this.esTramiteRecupero = RECUPERO_ACTIVIDADES.includes(actividadId);
    }

    async getSolicitud(): Promise<Solicitud> {
        this.solicitud =
            await this.solicitudesService.getSolicitudSeleccionada();
        this.actividad = this.solicitud.actividad;
        this.usuario = this.solicitud.usuario;
        this.nombrePais = this.solicitud.pais.name_es;

        console.log('solicitud', this.solicitud);
        return this.solicitud;
    }

    async getBeneficiario(solicitud: Solicitud) {
        try {
            this.beneficiario =
                await this.userEntreUserService.getBeneficiario(solicitud);
        } catch (error) {
            console.warn('No se pudo obtener el beneficiario:', error);
            this.beneficiario = null;
        }
    }

    async getEstadoSolicitud(solicitud: Solicitud) {
        const estadoReal = solicitud.lastState.numberState;
        // En Recupero, "En Espera" (6) es una pausa: se comporta como el
        // estado inmediatamente anterior (vuelve a ofrecer Mandar a Recupero,
        // Derivar a Auditoría o Aprobar según corresponda).
        const estadoEfectivo =
            estadoReal === 6 && this.esTramiteRecupero
                ? this.estadoRetornoEspera
                : estadoReal;

        // El stepper muestra el estado heredado cuando está en espera.
        this.estadoParaStepper =
            estadoReal === 6 ? this.estadoRetornoEspera : estadoReal;

        this.activarEnEspera = true;
        this.resetFlagsEstado();

        console.log(
            'solicitud.lastState.numberState',
            solicitud.lastState.numberState,
        );

        switch (estadoEfectivo) {
            case 0:
                this.activarRechazar = false;
                this.activarEnRevision = true;
                this.activarEnAuditoria = false;
                this.activarAprobar = true;

                this.activarRechazar = true;
                this.flagLabelPresentado = true;
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.pendiente;
                break;

            case 1:
                this.activarEnAuditoria = true;
                this.activarAprobar = true;
                this.activarEnRevision = true;
                this.activarRechazar = true;
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.pendiente;
                break;

            case 2:
                this.flagEnRevision = true;
                this.activarEnRevision = true;
                this.activarRechazar = true;
                this.activarEnAuditoria = true;
                this.activarAprobar = true;
                this.activarRechazar = true;
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.completo;
                break;

            case 3:
                this.activarEnRevision = false;
                this.activarRechazar = true;
                this.activarEnAuditoria = true;
                this.activarAprobar = true;
                this.activarRechazar = true;
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.completo;
                this.flagEnAuditoria = true;
                break;

            case 4:
                this.activarEnRevision = false;
                this.activarAprobar = false;
                this.activarEnAuditoria = false;
                this.flagLabelAprobado = true;
                this.activarRechazar = true;
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.completo;
                break;

            case 5:
                this.activarRechazar = false;
                this.flagLabelRechazado = true;
                this.activarEnEspera = false;
                this.activarDeshacerAnulacion = true;
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.completo;
                break;

            case 6:
                this.activarEnEspera = false;
                this.activarEnRevision = false;
                this.activarRechazar = true;
                this.activarEnAuditoria = true;
                this.activarAprobar = true;
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.completo;
                this.flagLabelEnEspera = true;
                this.flagEnRevision = false;
                break;

            default:
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.pendiente;
                break;
        }

        this.aplicarReglaAutorizacionRecupero(estadoEfectivo);

        // En Espera: no se vuelve a pausar y solo se informa la espera
        // (se ocultan las alertas del estado heredado).
        if (estadoReal === 6) {
            this.activarEnEspera = false;
            this.flagEnRevision = false;
            this.flagEnAuditoria = false;
            this.flagEnRecupero = false;
            this.flagLabelPresentado = false;
            this.flagLabelAprobado = false;
            this.flagLabelRechazado = false;
            this.flagLabelEnEspera = true;
        }

        this.ocultarAccionDelEstadoActual(estadoEfectivo);
    }

    /**
     * Limpia los flags de estado para evitar residuos entre recargas del
     * modal (al cambiar de estado algunos casos no los reescriben).
     */
    private resetFlagsEstado(): void {
        this.flagLabelPresentado = false;
        this.flagLabelAprobado = false;
        this.flagLabelRechazado = false;
        this.flagLabelEnEspera = false;
        this.flagEnRevision = false;
        this.flagEnAuditoria = false;
        this.flagEnRecupero = false;
    }

    /**
     * Oculta la acción que corresponde al estado actual de la solicitud:
     * no tiene sentido ofrecer "Poner en revisión" estando en Revisión,
     * "Derivar a Auditoría" estando en Auditoría, etc.
     */
    private ocultarAccionDelEstadoActual(estado: number): void {
        switch (estado) {
            case 2:
                this.activarEnRevision = false;
                break;
            case 3:
                this.activarEnAuditoria = false;
                break;
            case 4:
                this.activarAprobar = false;
                break;
            case 5:
                this.activarRechazar = false;
                break;
            case 6:
                this.activarEnEspera = false;
                break;
            case 7:
                this.activarEnRecupero = false;
                break;
        }
    }

    private aplicarReglaAutorizacionRecupero(estado: number): void {
        if (!this.esTramiteRecupero) {
            return;
        }

        this.flagEnRecupero = estado === 7;

        // Mandar a Recupero: SEDE/RECUPEROSUR/AUDITORIA/ADMIN/SYSADMIN desde Presentado/Documentación/Revisión
        this.activarEnRecupero =
            this.PERFILES_MANDAR_RECUPERO.includes(this.userPerfilKey) &&
            [0, 1, 2].includes(estado);

        // Poner en revisión: SEDE/RECUPEROSUR/AUDITORIA/ADMIN/SYSADMIN desde Presentado/Documentación.
        this.activarEnRevision =
            this.PERFILES_MANDAR_RECUPERO.includes(this.userPerfilKey) &&
            [0, 1].includes(estado);

        // Salir de espera (6) se resuelve en getEstadoSolicitud (pausa).

        // Derivar a Auditoría Médica: RECUPEROSUR/AUDITORIA/ADMIN/SYSADMIN desde Recupero (7)
        this.activarEnAuditoria =
            this.PERFILES_DERIVAR_AUDITORIA.includes(this.userPerfilKey) &&
            estado === 7;

        // Resolución: Aprobar solo AUDITORIA/ADMIN/SYSADMIN desde Auditoría Médica (3).
        this.activarAprobar =
            this.PERFILES_RESOLUCION_AUDITORIA.includes(this.userPerfilKey) &&
            estado === 3;

        // Anular: disponible para TODOS los perfiles del circuito, salvo ya anulado (5)
        this.activarRechazar =
            this.PERFILES_TODOS.includes(this.userPerfilKey) && estado !== 5;

        // En Espera: solo desde Auditoría Médica (3). En Revisión (2) y
        // Recupero (7) no se puede pausar.
        this.activarEnEspera =
            this.PERFILES_TODOS.includes(this.userPerfilKey) &&
            estado === 3;
    }

    async getArrayImgsAndFile(adjuntos: string[]) {
        console.log('Adjuntos recibidos:', adjuntos);
        this.imgs = [];
        this.filesAfiliado = [];
        this.filesAdmin = [];
        adjuntos.forEach((element) => {
            if (element.toLowerCase().includes('.pdf')) {
                if (this.esDocumentoDeAdministracion(element)) {
                    this.filesAdmin.push(element);
                } else {
                    this.filesAfiliado.push(element);
                }
            } else {
                this.imgs.push(element);
            }
        });
        console.log(
            'Imagenes:',
            this.imgs,
            'Archivos afiliado:',
            this.filesAfiliado,
            'Archivos admin:',
            this.filesAdmin,
        );
    }

    /**
     * El archivo que carga el administrador al aprobar la solicitud se guarda
     * con el _id de la solicitud como primer segmento del nombre (el service
     * pisa el idAdjunto por el idSolicitud). Ver media.service.ts.
     */
    private esDocumentoDeAdministracion(adjunto: string): boolean {
        return (
            !!this.solicitud &&
            adjunto.split('.')[0] === this.solicitud._id
        );
    }

    verImagen(img: string) {
        const imagenes = this.imgs.map((i) => ({
            url: `${environment.urlBackend}/media/imgUserOffer/${this.usuario._id}/${i}`,
            titulo: this.nombresImagenes[i] || 'Visualización de Imagen',
        }));
        const index = this.imgs.indexOf(img);
        this.dialog.open(OfertasImageViewerComponent, {
            data: { imagenes, index: index < 0 ? 0 : index },
            width: 'min(1100px, 94vw)',
            maxWidth: '94vw',
            maxHeight: '98vh',
            panelClass: 'ds-dialog'
        });
    }

    descargarImagenPDF(img: string) {
        const url = `${environment.urlBackend}/media/image-pdf/${this.usuario._id}/${img}`;
        window.open(url, '_blank');
    }

    async setNombresAdjuntos() {
        if (!this.imgs || this.imgs.length === 0) return;

        for (const img of this.imgs) {
            try {
                if (!img) continue;

                if (img === 'ADJUNTO_CONTRATO') {
                    this.nombresImagenes[img] = 'Adjunto Contrato';
                    continue;
                }

                const idAdjunto = img.includes('.') ? img.split('.')[0] : img;
                const docEncontrado = this.solicitud?.documentosEstadosSolicitar?.find(
                    (doc) => doc.documento?._id === idAdjunto
                );

                if (docEncontrado && docEncontrado.documento) {
                    this.nombresImagenes[img] = docEncontrado.documento.nombre;
                    continue;
                }

                let nombre = await this.actividadesService.getNombreAdjunto(img);
                if (!nombre) {
                    nombre = await this.usuarioService.getNombreAdjunto(img);
                }

                if (!nombre || idAdjunto === this.solicitud?._id) {
                    this.nombresImagenes[img] = 'Documento Extra';
                } else {
                    this.nombresImagenes[img] = nombre;
                }
            } catch (error) {
                console.error('Error resolviendo nombre para:', img, error);
                this.nombresImagenes[img] = 'Documento Extra';
            }
        }
    }

    async cargarAdjuntoContrato() {
        this.adjuntoCatalogo =
            await this.catalogoService.getFindByKey('ADJUNTO_CONTRATO');
    }

    openDialog(label: string, estado: string, idAdjunto: string): void {
        const dialogRef = this.dialog.open(UploadFileSolicitudComponent, {
            width: '800px',
            height: '800px',
            disableClose: true,
            data: {
                solicitud: this.solicitud,
                adjunto: idAdjunto,
                label,
                numberState: estado,
                labelButton: 'ENVIAR CONTRATO',
                accept: 'application/pdf',
            },
        });

        dialogRef.afterClosed().subscribe(async (result) => {
            if (result) {
                await this.refreshComponent('autorizaciones-listado');

                const messageDto = await this.mailerService.prepareMailToSend(
                    this.solicitud.usuario,
                    await this.getSolicitud(),
                    true,
                    this.adjuntoCatalogo.properties._idAdjunto,
                    'TEMPLATE_MAILER_CONTRATO',
                );

                await this.mailerService.sendMail(messageDto);

                this.dataModal = result;
            }
        });
    }

    refreshComponent(url) {
        this.router
            .navigateByUrl(url, { skipLocationChange: true })
            .then(async () => {
                await this.closeModal();
                await this.openDialogModaSolicitud();
            });
    }

    openDialogModaSolicitud(): void {
        const dialogRef = this.dialog.open(OfertasSolicitudComponent, {
            width: '900px',
            height: '1000px',
            disableClose: true,
            panelClass: 'ds-dialog',
        });
        dialogRef.afterClosed().subscribe(async (result) => {});
        return;
    }

    closeModal(): void {
        this.dialogRef.close();
    }

    async desactivarBotones() {
        this.activarEnRevision = false;
        this.activarEnAuditoria = false;
        this.activarRechazar = false;
        this.activarAprobar = false;
        this.activarEnRecupero = false;
        this.activarCerrarModal = false;
        this.isCheckedAprobar = false;
        this.isCheckedRechazar = false;
        this.isCheckedEnRevision = false;
        this.activarEnEspera = false;
        this.isCheckedEnEspera = false;
    }

    async mandarARecupero() {
        // La observacion de Recupero es interna: va a `observacionRecupero` y no
        // a `observaciones`, asi el afiliado no la ve ni la recibe por mail.
        await this.actualizarEstadoSolicitud(
            this.solicitud._id,
            this.iAppOfertas.estado_7.number,
            false,
            this.iAppOfertas.estado_7.name,
            true,
            undefined,
            undefined,
            this.observacionRecupero,
        );
        this.observacionRecupero = '';
    }

    async limpiarTexto() {
        this.motivoRevision = '';
        this.motivoRechazo = '';
        this.motivoEnEspera = '';
    }

    async habilitarBotonObservaciones(motivo: string) {
        this.habilitarEnviarObservacion = motivo.trim() !== '';
    }

    async botonDerivarAuditoriaMedica() {
        this.actualizarEstadoSolicitud(
            this.solicitud._id,
            this.iAppOfertas.estado_3.number,
            false,
            this.iAppOfertas.estado_3.name,
            true,
        );
        this.botonAuditoriaHabilitado = false;
        this.mostrarLeyenda = true;
        this.solicitudesService.solicitudEnviarDocumentosYnotificar(
            this.solicitud._id,
            this.observacionEmailAuditoriaMedica,
        );
    }

    async actualizarEstadoSolicitud(
        _id: string,
        numberState: number,
        notificaAdmin: boolean,
        state?: string,
        notificar?: boolean,
        observaciones?: string,
        file?: string,
        observacionRecupero?: string,
    ) {
        console.log(
            'Actualizando estado a:',
            numberState,
            'Nombre estado:',
            state,
        );
        console.log('Motivo proporcionado:', observaciones);

        await this.desactivarBotones();
        await this.limpiarTexto();
        this.activarDeshacerAnulacion = false;

        this.flagSpinner = true;

        this.solicitudesService
            .updateSolicitudState(
                _id,
                numberState,
                notificaAdmin,
                state,
                notificar,
                observaciones,
                file,
                observacionRecupero,
            )
            .then(async (solicitudUpdated: Solicitud) => {
                await this.solicitudesService.setSolicitudSeleccionada(
                    solicitudUpdated,
                );
                this.flagSpinner = false;
                this.solicitudesService.setNewState(solicitudUpdated);
                this.modalCustom.abrirPopup({
                    tipo: 'success',
                    titulo: 'Estado actualizado',
                    mensaje: 'El estado de la solicitud se actualizó correctamente.',
                    textoBoton: 'Entendido',
                });
            })
            .catch((error) => {
                console.log(error);
                this.flagSpinner = false;
                this.modalCustom.abrirPopup({
                    tipo: 'error',
                    titulo: 'No se pudo actualizar',
                    mensaje: 'Ocurrió un error al cambiar el estado. Intentá nuevamente.',
                    textoBoton: 'Entendido',
                });
            });
    }

    async deshacerAnulacion() {
        await this.actualizarEstadoSolicitud(
            this.solicitud._id,
            this.iAppOfertas.estado_2.number,
            false,
            this.iAppOfertas.estado_2.name,
            true,
            'Anulación revertida - La solicitud vuelve a revisión',
        );
    }

    enviarDocumentosSolicitud(idSolicitud: string): void {
        this.modalCustom.abrirPopup({
            tipo: 'warning',
            titulo: '¿Está seguro?',
            mensaje:
                'Si confirmas, se reenviarán todos los documentos adjuntos, junto con el detalle de la solicitud y las observaciones, al departamento de Auditoría Médica.',
            textoBoton: 'Sí, enviar',
            textoBotonCancelar: 'Cancelar',
            accionConfirmar: () => this.procesarEnvioDocumentos(idSolicitud),
        });
    }

    private async procesarEnvioDocumentos(idSolicitud: string): Promise<void> {
        this.flagSpinner = true;
        try {
            await this.solicitudesService.solicitudEnviarDocumentosYnotificar(
                idSolicitud,
                this.observacionEmailAuditoriaMedica
            );

            this.observacionEmailAuditoriaMedica = '';

            this.modalCustom.abrirPopup({
                tipo: 'success',
                titulo: 'Documentos enviados',
                mensaje: 'Los documentos han sido enviados exitosamente a Auditoría Médica.',
                textoBoton: 'Entendido',
            });
        } catch (error) {
            this.modalCustom.abrirPopup({
                tipo: 'error',
                titulo: 'No se pudieron enviar',
                mensaje: 'Ocurrió un error al enviar los documentos. Intentá nuevamente.',
                textoBoton: 'Entendido',
            });
        } finally {
            this.flagSpinner = false;
        }
    }

    addFileRow() {
        this.selectedFiles.push({ fileName: '', file: null });
    }

    // Método para manejar la selección de archivos
    onFileSelected(event: Event, index: number) {
        const fileInput = event.target as HTMLInputElement;
        const files: FileList | null = fileInput.files;

        if (files) {
            // Si hay un archivo seleccionado, lo agregamos al grupo correspondiente
            this.selectedFiles[index].file = files[0];
            this.selectedFiles[index].fileName = files[0].name;
            this.controlButtonState();
        }
    }

    controlButtonState() {
        if (this.selectedFiles.length > 0) {
            this.flagDisableButtonApprove = false; // Habilitar el botón si hay archivos seleccionados
        } else {
            this.flagDisableButtonApprove = true; // Deshabilitar si no hay archivos
        }
    }

    removeFile(index: number) {
        this.selectedFiles.splice(index, 1);
        this.controlButtonState();
    }

    async aprobarSolicitud(): Promise<void> {
        console.log(
            'OfertasSolicitudComponent: Iniciando aprobación de solicitud',
        );

        this.flagSpinner = true;
        const mergedBlob = await this.mergePdfsClientSide(
            this.selectedFiles.map((fg) => fg.file),
        );

        const mergedFile = new File(
            [mergedBlob],
            `solicitud-${this.solicitud._id}-docs.pdf`,
            { type: 'application/pdf' },
        );

        const nextState = this.iAppOfertas.estado_4.number;
        const nextStateName = this.iAppOfertas.estado_4.name;

        this.flagDisableButtonApprove = true;
        if (this.mediaService.controlContador()) {
            await this.uploadDocumentoAdjunto(
                mergedFile,
                true,
                nextState,
                nextStateName,
            );
            this.mediaService.reiniciarContadorControlUpload();

            if (this.flagCargaCorrecta) {
                this.modalCustom.abrirPopup({
                    tipo: 'success',
                    titulo: 'Trámite aprobado',
                    mensaje: 'La solicitud fue aprobada y se envió la autorización al afiliado.',
                    textoBoton: 'Entendido',
                    accionConfirmar: () => this.dialogRef.close(true),
                });
            } else {
                this.flagSpinner = false;
                this.modalCustom.abrirPopup({
                    tipo: 'error',
                    titulo: 'No se pudo aprobar',
                    mensaje: 'Ocurrió un error al subir la autorización. Intentá nuevamente.',
                    textoBoton: 'Entendido',
                });
            }
        }
    }

    async uploadDocumentoAdjunto(
        file: File,
        autorizo: boolean,
        nextState?: number,
        nextStateName?: string,
    ) {
        let idUsuario;
        let idAdjunto = 'idAdjunto';

        if (this.solicitud.usuario.hasOwnProperty('_id')) {
            idUsuario = this.solicitud.usuario._id;
        } else {
            idUsuario = this.solicitud.usuario;
        }

        const upLoadedFile =
            await this.mediaService.uploadOneAttachJobOfferFromWeb(
                file,
                idUsuario,
                idAdjunto,
                this.solicitud._id,
                autorizo,
            );

        if (upLoadedFile['ok']) {
            const idAdjunto =
                upLoadedFile.solicitud.adjuntos[
                    upLoadedFile.solicitud.adjuntos.length - 1
                ];

            const stateNumber =
                nextState !== undefined
                    ? nextState
                    : this.iAppOfertas.estado_4.number;
            const stateName =
                nextStateName !== undefined
                    ? nextStateName
                    : this.iAppOfertas.estado_4.name;

            await this.actualizarEstadoSolicitud(
                this.solicitud._id,
                stateNumber,
                false,
                stateName,
                true,
                'Autorización APROBADA - Se adjunta autorización en este email',
                idAdjunto,
            );

            if (this.value === 100) {
                this.solicitudesService.setSolicitudSeleccionada(
                    upLoadedFile.solicitud,
                );
                this.flagCargaCorrecta = true;
            }
        } else {
            this.flagCargaCorrecta = false;
        }
    }

    async mergePdfsClientSide(files: File[]): Promise<Blob> {
        const mergedPdf = await PDFDocument.create();

        for (const file of files) {
            const arrayBuffer = await file.arrayBuffer();
            const pdf = await PDFDocument.load(arrayBuffer);
            const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
            pages.forEach((page) => mergedPdf.addPage(page));
        }

        const mergedBytes = await mergedPdf.save();
        const mergedBytesArray = new Uint8Array(mergedBytes);
        return new Blob([mergedBytesArray], { type: 'application/pdf' });
    }

    async derivarYAudiarSolicitud(idSolicitud: string): Promise<void> {
        this.modalCustom.abrirPopup({
            tipo: 'warning',
            titulo: '¿Está seguro?',
            mensaje:
                'Si confirma, la solicitud pasará a Auditoría Médica, cambiará de estado y se enviarán todos los documentos adjuntos, junto con el detalle de la solicitud y las observaciones.',
            textoBoton: 'Sí, derivar y enviar',
            textoBotonCancelar: 'Cancelar',
            accionConfirmar: () => this.procesarDerivacion(idSolicitud),
        });
    }

    private async procesarDerivacion(idSolicitud: string): Promise<void> {
        this.flagSpinner = true;

        try {
            await this.actualizarEstadoSolicitud(
                idSolicitud,
                this.iAppOfertas.estado_3.number,
                false,
                this.iAppOfertas.estado_3.name,
                true,
                this.observacionEmailAuditoriaMedica,
            );

            this.observacionEmailAuditoriaMedica = '';

            this.modalCustom.abrirPopup({
                tipo: 'success',
                titulo: 'Operación exitosa',
                mensaje:
                    'La solicitud ha sido derivada a Auditoría Médica y los documentos han sido enviados.',
                textoBoton: 'Entendido',
            });
        } catch (error) {
            console.error('Error al derivar o enviar a auditoría:', error);
            this.modalCustom.abrirPopup({
                tipo: 'error',
                titulo: 'Error',
                mensaje: 'Hubo un problema al procesar la solicitud. Por favor, intente nuevamente.',
                textoBoton: 'Entendido',
            });
        } finally {
            this.flagSpinner = false;
        }
    }

    get historialConUsuario(): any[] {
        return this.solicitud?.states
            ? this.solicitud.states.filter(
                  (s) =>
                      !!s.userName &&
                      s.numberState !== 0 &&
                      s.numberState !== 1,
              )
            : [];
    }

    /** Nombres de estado como los muestra el stepper del modal. */
    private readonly NOMBRE_ESTADO: Record<number, string> = {
        0: 'Presentado',
        1: 'Documentación',
        2: 'En revisión',
        3: 'En auditoría médica',
        4: 'Aprobado',
        5: 'Anulado',
        6: 'En espera',
        7: 'Recupero',
    };

    /**
     * Observaciones que dejaron los pasos anteriores: las públicas del estado y
     * la interna de Recupero. Van como avisos dentro de la tarjeta de estado, no
     * como un bloque aparte — es información del paso, no un artefacto de la
     * solicitud. La más nueva primero.
     */
    get observacionesPasos(): {
        estado: string;
        texto: string;
        interna: boolean;
    }[] {
        const estados = this.solicitud?.states ?? [];
        const ultimo = estados.length - 1;

        return estados
            .map((state, index) => ({ state, index }))
            .reverse()
            .filter(({ state, index }) => {
                const texto = (state.observacionRecupero || state.observaciones || '').trim();
                if (!texto) {
                    return false;
                }
                // Anulado (5) y en espera (6) ya muestran su motivo en el aviso
                // del estado actual: no se repiten acá.
                const yaVisible =
                    index === ultimo && (state.numberState === 5 || state.numberState === 6);
                return !yaVisible;
            })
            .map(({ state }) => {
                const interna = (state.observacionRecupero || '').trim();
                return {
                    estado:
                        this.NOMBRE_ESTADO[state.numberState] ??
                        `estado ${state.numberState}`,
                    texto: interna || (state.observaciones || '').trim(),
                    interna: !!interna,
                };
            });
    }

    async guardarObservacionInterna(): Promise<void> {
        try {
            this.flagSpinner = true;

            const respuesta =
                await this.solicitudesService.updateSolicitudObservacionInterna(
                    this.solicitud._id,
                    this.solicitud,
                    this.observacionInterna,
                );

            if (respuesta) {
                this.solicitud = respuesta;
                this.solicitudesService.setSolicitudSeleccionada(respuesta);

                this.modalCustom.abrirPopup({
                    tipo: 'success',
                    titulo: 'Observación interna guardada',
                    mensaje: 'La observación interna se guardó correctamente.',
                    textoBoton: 'Entendido',
                });
            } else {
                throw new Error('Respuesta vacía del servidor');
            }
        } catch (error) {
            console.error('Error al guardar observación interna:', error);

            this.modalCustom.abrirPopup({
                tipo: 'error',
                titulo: 'Error',
                mensaje:
                    'No se pudo guardar la observación interna. Por favor, intente nuevamente.',
                textoBoton: 'Entendido',
            });
        } finally {
            this.flagSpinner = false;
        }
    }

    async habilitarBotonObservacionesInternas(motivo: string) {
        this.habilitarGuardarObservacionInterna = motivo.trim() !== '';
    }
}